module.exports = __webpack_public_path__ + "img/dpsj.5e142fb3.svg";